import * as React from 'react';

import classNames from 'classnames';

import { Icon } from '@base/components/Icon';

import { IconStarStroked } from '@icons';

import { IRatingBarProps, IRatingBarState } from './types';

import * as s from './RatingBar.scss';

const MAX_RATING_DEFAULT = 5;

export class RatingBar extends React.PureComponent<IRatingBarProps, IRatingBarState> {

	onClickRatingMarker = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
		const markerNode = event.currentTarget;
		const ratingValue = markerNode?.dataset?.rating && Number(markerNode.dataset.rating) || 0;

		this.props.onClickRatingMarker(ratingValue);
	};

	renderStars = () => {
		const {
			starClassName,
			appRating,
			maxRating = MAX_RATING_DEFAULT,
		} = this.props;

		return new Array(maxRating)
			.fill(null)
			.map((el: null, index: number) => {
				const isActiveStar = index < appRating;

				const className = classNames(
					s.star,
					{ [isActiveStar ? s.active : s.gray]: !!appRating },
				);

				return (
					<span
						className={starClassName}
						key={index}
						data-rating={index+1}
						onClick={this.onClickRatingMarker}
					>
						<Icon
							glyph={IconStarStroked}
							className={s.starIcon}
							classNameSvg={className}
						/>
					</span>

				);
			});
	};

	render() {
		const stars = this.renderStars();

		return (
			<div className={classNames(s.block, this.props.className)}>
				<div className={s.bar}>
					{stars}
				</div>
			</div>
		);
	}

}
